// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"00eace0f","24":"251cbd61","119":"aae253da","133":"688b0028","186":"f60418fe","315":"0e92091b","344":"45345f66","372":"d8d6690e","377":"5cdf3e61","434":"97fa2128","453":"70a066f5","738":"ea8334f5","815":"832e7ad6","841":"e2e8eb7c","856":"781e5765"}[chunkId] + ".chunk.js";
};